var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('ServicePart',{attrs:{"ser-desc":[
      {
        title: 'Magic of Development',
        description:
          'We can help wholesalers design beautiful and awesome products and provide other customizaitons.',
        link:
          'https://img.cnsian.com/images/12ef986599be33616afaef39ba51c986.gif'
      },
      {
        title: 'Dealer',
        description:
          'We have our own progressive brand and you can profit much from purchasing here.',
        link:
          'https://img.cnsian.com/images/cd5c6769d0aff532c144e2f5ae7654ec.jpg'
      },
      {
        title: 'Fast Delivery',
        description:
          'We do our best to optimize the producing procedure and work with reliable delivery service company.',
        link:
          'https://img.cnsian.com/images/0754d21f29493655a97cd72ed5773b94.jpg'
      },
      {
        title: 'Exquisite Packaged',
        description:
          'We provide customized packaging service for promotion and wrapping as gifts.',
        link:
          'https://img.cnsian.com/images/285389e6a477a7f3e555b26d4e2f3f3e.jpg'
      },
      {
        title: 'Easy to Work With',
        description:
          'We have provided detailed information about our products as well as professional salesman to help new wholesalers succeed.',
        link:
          'https://img.cnsian.com/images/83ac070b40b6aa1db939dcfeed3cedd0.jpg'
      },
      {
        title: 'Environment Friendly',
        description:
          'Create products that are environment-friendly, promote conservation of resources and energy, reduce waste materials, and maintain and improve the health of the environment through our business activities.',
        link:
          'https://img.cnsian.com/images/2c81132a406e1cd7f592f28127d4b874.jpg'
      }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }